<template>
    <div class="configurator-slider">
        <span :class="['icon',  part.icon]"></span>
        <h3>{{resources.screens.containerPicker.heading}}</h3>

        <div class="configurator-slider-body">
            <VueSlickCarousel v-bind="sliderSettings" ref="carousel" @beforeChange="onBeforeChange">
                <product-image v-for="(option, idx) in part.options"
                    :className="(idx === currentSlide) ? 'selected' : ''"
                    :image="option.thumb">
                </product-image>
            </VueSlickCarousel>
        </div>

        <slider-controls
            :showLeftArrow="showLeftArrow"
            :showRightArrow="showRightArrow"
            @clickArrowLeft="onClickArrowLeft()"
            @clickArrowRight="onClickArrowRight()">
        </slider-controls>

        <div class="configurator-slider-footer">
            <div class="part-details">
                <transition name="error-message-transition">
                    <span class="error-message" v-show="!partAvailable">
                        <span class="error-badge"></span>
                        {{resources.global.notInStockShort}}
                    </span>
                </transition>

                <span :class="['part-name', {'not-available': !partAvailable}]">
                    {{partName}}
                </span>
            </div>

            <button type="button" class="btn btn-customize" @click="nextScreen()" :disabled="!partAvailable">
                {{resources.screens.containerPicker.chooseButtonLabel}}
            </button>
        </div>
    </div>
</template>

<script src="./product-slider.js"></script>
